import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { ModalService } from '../services/modal.service';

@Component({
  selector: 'review-order-submitted-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './review-order-submitted-dialog.component.html',
  styleUrl: './review-order-submitted-dialog.component.scss',
})
export class ReviewOrderSubmittedDialogComponent {
  @Input() active: boolean = false;
  @Output() modalClosed = new EventEmitter<boolean>();

  @Input() documents: any = '';
  @Input() siteType: string = '';
  @Input() siteSubType: string = '';
  @Input() address: any = { streetAddress: '', cityStateZip: '' };
  @Input() title: string = '';

  constructor(private modalService: ModalService) {}

  ngOnInit() {
    this.modalService.submissionConfirmationDialogTitle.subscribe(
      (currentTitle: string) => (this.title = currentTitle)
    );
  }

  closeDialog() {
    this.active = false;
    this.modalClosed.emit(this.active);
  }
  submit() {
    this.closeDialog();
    this.modalService.updateSubmissionConfirmationDialogTitle('');
  }
}
